import { render, staticRenderFns } from "./CtaImage.vue?vue&type=template&id=082d6762"
import script from "./CtaImage.vue?vue&type=script&lang=js"
export * from "./CtaImage.vue?vue&type=script&lang=js"
import style0 from "./CtaImage.vue?vue&type=style&index=0&id=082d6762&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports